module.exports = __webpack_public_path__ + "42ca58aac70dcbf37231efc10a829313.svg";